import { useState } from "react";
import { Plus, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { MenuImageField } from "./MenuImageField";

const inp = "w-full h-10 px-3 rounded-lg border text-sm outline-none focus:ring-2 focus:ring-[#B91C1C]";

export function MenuFormDialog({ item, variants, categories, onClose, onSave }) {
  const [f, setF] = useState({
    name: "", description: "", price: 0, category: categories[0] || "Nasi", image: "", options: [], available: true, popular: false, loyverse_variant_id: "", show_in_app: true, ...item,
  });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [uploading, setUploading] = useState(false);
  const setOpt = (i, k, v) => set("options", f.options.map((o, j) => (j === i ? { ...o, [k]: v } : o)));

  const submit = (e) => {
    e.preventDefault();
    const { id, sort_order, ...body } = f;
    onSave({ ...body, category: body.category.trim(), price: Number(body.price), options: body.options.filter((o) => o.name.trim()).map((o) => ({ name: o.name, price_delta: Number(o.price_delta) || 0, loyverse_variant_id: o.loyverse_variant_id || "" })) });
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="menu-form-dialog">
        <DialogHeader><DialogTitle className="font-display">{item.id ? "Kemaskini Menu" : "Tambah Menu"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3 text-sm">
          <input required value={f.name} onChange={(e) => set("name", e.target.value)} placeholder="Nama menu" data-testid="menu-form-name" className={inp} />
          <textarea value={f.description} onChange={(e) => set("description", e.target.value)} placeholder="Penerangan" data-testid="menu-form-desc" className={`${inp} h-20 py-2`} />
          <div className="grid grid-cols-2 gap-3">
            <input required type="number" step="0.01" min="0" value={f.price} onChange={(e) => set("price", e.target.value)} placeholder="Harga (RM)" data-testid="menu-form-price" className={inp} />
            <input required list="menu-categories" value={f.category} onChange={(e) => set("category", e.target.value)} placeholder="Kategori" data-testid="menu-form-category" className={inp} />
            <datalist id="menu-categories">{categories.map((c) => <option key={c} value={c} />)}</datalist>
          </div>
          <MenuImageField value={f.image} onChange={(v) => set("image", v)} inputCls={inp} onBusy={setUploading} />
          <div>
            <div className="flex items-center justify-between mb-2"><b>JIKA NAK TAMBAH</b>
              <button type="button" onClick={() => set("options", [...f.options, { name: "", price_delta: 0 }])} data-testid="menu-form-add-option" className="text-[#B91C1C] flex items-center gap-1 text-xs font-semibold"><Plus className="w-3 h-3" />Tambah</button>
            </div>
            {f.options.map((o, i) => (
              <div key={i} className="flex gap-2 mb-2">
                <input value={o.name} onChange={(e) => setOpt(i, "name", e.target.value)} placeholder="Nama pilihan" className={inp} />
                <input type="number" step="0.01" value={o.price_delta} onChange={(e) => setOpt(i, "price_delta", e.target.value)} placeholder="+RM" className={`${inp} w-28`} />
                <button type="button" onClick={() => set("options", f.options.filter((_, j) => j !== i))} className="p-2 text-red-600"><X className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
          <div>
            <b>Padanan Loyverse</b>
            {variants.length > 0 ? (
              <select value={f.loyverse_variant_id} onChange={(e) => set("loyverse_variant_id", e.target.value)} data-testid="menu-form-loyverse" className={`${inp} mt-1`}>
                <option value="">— Tiada —</option>
                {variants.map((v) => <option key={v.variant_id} value={v.variant_id}>{v.label}</option>)}
              </select>
            ) : (
              <input value={f.loyverse_variant_id} onChange={(e) => set("loyverse_variant_id", e.target.value)} placeholder="Loyverse variant ID (pilihan)" data-testid="menu-form-loyverse" className={`${inp} mt-1`} />
            )}
          </div>
          <label className="flex items-center justify-between"><span>Papar dalam app pelanggan<span className="block text-xs text-slate-500">Matikan untuk menu POS sahaja</span></span><Switch checked={f.show_in_app !== false} onCheckedChange={(v) => set("show_in_app", v)} data-testid="menu-form-show-in-app" /></label>
          <label className="flex items-center justify-between"><span>Tersedia</span><Switch checked={f.available} onCheckedChange={(v) => set("available", v)} data-testid="menu-form-available" /></label>
          <button type="submit" disabled={uploading} data-testid="menu-form-save" className="w-full h-11 rounded-xl bg-[#B91C1C] text-white font-semibold disabled:opacity-60">{uploading ? "Memuat naik gambar..." : "Simpan"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
